export const NO_CONTENT_VALUE = "—";

export enum HTTPStatus {
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
}

export const ADMIN_ROLE = "__superuser";
